"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CompanyInvoiceType;
(function (CompanyInvoiceType) {
    CompanyInvoiceType["Division"] = "Division";
    CompanyInvoiceType["Invoice"] = "Invoice";
    CompanyInvoiceType["Date"] = "Date";
    CompanyInvoiceType["Remittance"] = "Remittance";
    CompanyInvoiceType["Disbursement"] = "Disbursement";
    CompanyInvoiceType["PaymentConfirmation"] = "PaymentConfirmation";
})(CompanyInvoiceType = exports.CompanyInvoiceType || (exports.CompanyInvoiceType = {}));
//# sourceMappingURL=CompanyInvoiceType.js.map